var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#4b4495;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Your_profile",
    "data-name": "Your profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15285",
    "data-name": "Group 15285"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17425",
    "data-name": "Rectangle 17425",
    className: "cls-1",
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15287",
    "data-name": "Group 15287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15286",
    "data-name": "Group 15286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29344",
    "data-name": "Path 29344",
    className: "cls-2",
    d: "M9,15c-2.67,0-8,1.34-8,4v2H17V19C17,16.34,11.67,15,9,15ZM3,19c.22-.72,3.31-2,6-2s5.8,1.29,6,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29345",
    "data-name": "Path 29345",
    className: "cls-2",
    d: "M4.74,9H5a4,4,0,0,0,8,0h.26a.49.49,0,0,0,.49-.49v0A.49.49,0,0,0,13.26,8H13a4,4,0,0,0-2-3.45v1a.5.5,0,0,1-1,0V4.14A4.23,4.23,0,0,0,9,4a4.23,4.23,0,0,0-1,.14V5.5a.5.5,0,0,1-1,0v-1A4,4,0,0,0,5,8H4.74a.49.49,0,0,0-.49.49v0A.48.48,0,0,0,4.74,9ZM11,9A2,2,0,0,1,7,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29346",
    "data-name": "Path 29346",
    className: "cls-2",
    d: "M22,6.23l.93-.83-.75-1.3L21,4.49a2,2,0,0,0-.47-.27L20.25,3h-1.5L18.5,4.22a2.27,2.27,0,0,0-.48.27L16.84,4.1l-.75,1.3.93.83a2.26,2.26,0,0,0,0,.52l-.93.85.75,1.3L18,8.52a2.3,2.3,0,0,0,.43.25L18.75,10h1.5l.27-1.22A2.38,2.38,0,0,0,21,8.53l1.19.38.75-1.3L22,6.76A2.35,2.35,0,0,0,22,6.23ZM19.5,7.75A1.25,1.25,0,1,1,20.75,6.5,1.25,1.25,0,0,1,19.5,7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29347",
    "data-name": "Path 29347",
    className: "cls-2",
    d: "M19.4,10.79l-.85.28a1.35,1.35,0,0,0-.33-.19L18,10H17l-.18.87a1.63,1.63,0,0,0-.34.19l-.84-.28-.54.93.66.59a2.29,2.29,0,0,0,0,.37l-.66.61.54.93.86-.27a1.92,1.92,0,0,0,.31.18L17,15H18l.19-.87a2,2,0,0,0,.32-.18l.85.27.54-.93-.66-.61a2.29,2.29,0,0,0,0-.37l.66-.59Zm-1.9,2.6a.89.89,0,1,1,.89-.89h0A.89.89,0,0,1,17.5,13.39Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.d3e712f7072c25261f27ac84987cf289.svg";
export { ForwardRef as ReactComponent };